<template>
  <div>
    <b-skeleton-wrapper :loading="refresh">
      <template #loading>
        <b-row class="my-3">
          <b-col>
            <b-skeleton width="50%" height="40px" />
          </b-col>
          <b-col class="d-flex justify-content-end">
            <b-skeleton width="30%" height="40px" />
          </b-col>
        </b-row>
        <b-card class="p-4">
          <b-row class="my-3">
            <b-col>
              <b-skeleton width="50%" height="40px" />
            </b-col>
            <b-col class="d-flex justify-content-end">
              <b-skeleton width="30%" height="40px" />
            </b-col>
          </b-row>
          <b-skeleton width="100%" height="300px" />
        </b-card>
      </template>
      <div class="row">
        <div class="col-12">
          <!-- Table -->
          <div class="table-responsive m-3">
            <McGrapqlTable
              :apiClient="query"
              :fields="fields"
              :hasCheckbox="true"
              :searchable="true"
              :withCard="true"
              :isSelectableField="false"
              trackBy="id"
              :hasStore="{ delete: 'maintenance/DELETE_VEHICLE' }"
              :isEmpty="!hasData"
              :customToast="customToast"
              :customButton="true"
            >
              <template #title>
                <h4>{{ $t('global.object.fleetList') }}</h4>
              </template>

              <template #button-value-help>
                <McButtonValueHelp
                  icon="icon-fill_plus"
                  :text="$t('global.create')"
                  variant="primary"
                  :label="$t('global.object.addFleet')"
                  :multiple="true"
                  trackBy="id"
                  :listGetter="resourcefulQuery.vehicles"
                  :tableFields="optionsFields"
                  :hasSelectAll="true"
                  @selected="selectedVehicles"
                  @exclude="excludedIds"
                />
              </template>

              <template #cell(manufacturer)="data">
                {{ data.item.vehicleType.manufacturer + ' - ' + data.item.vehicleType.model }}
              </template>

              <template #emptyState>
                <McEmptyState
                  :title="$t('maintenance.nolist.vehicleTitle')"
                  :desc="$t('maintenance.nolist.vehicleDesc')"
                  class="pb-4"
                  :hasButton="false"
                  :isDisabled="isDuplicate"
                >
                  <template #button-value-help>
                    <McButton
                      v-if="hasTemplate"
                      icon="icon-fill_plus"
                      :text="$t('global.create')"
                      @click="openModal"
                    />
                    <McButtonValueHelp
                      v-else
                      icon="icon-fill_plus"
                      :text="$t('global.create')"
                      variant="primary"
                      :label="$t('global.object.addFleet')"
                      :multiple="true"
                      trackBy="id"
                      :listGetter="resourcefulQuery.vehicles"
                      :tableFields="optionsFields"
                      :disabled="disabled"
                      :hasSelectAll="true"
                      @selected="selectedVehicles"
                      @exclude="excludedIds"
                    />
                  </template>
                </McEmptyState>
              </template>
            </McGrapqlTable>
          </div>
        </div>
      </div>
    </b-skeleton-wrapper>
    <b-modal
      id="mc-modal-confirm"
      class="mc-modal"
      centered
      size="md"
      :title="$t('global.confirmation.title')"
    >
      <div class="card-body p-2">
        <p>
          {{ $t('global.confirmation.questionAddFleet') }}
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="d-flex">
          <McButton
            variant="secondary"
            class="me-2"
            :text="$t('global.cancel')"
            @click="cancel()"
          />
          <McButtonValueHelp
            ref="valueHelpFleetRef"
            :text="$t('global.action.continue')"
            variant="primary"
            :label="$t('global.object.addFleet')"
            :multiple="true"
            trackBy="id"
            :listGetter="resourcefulQuery.vehicles"
            :tableFields="optionsFields"
            :hasPopup="true"
            :hasSelectAll="true"
            popupId="mc-modal-confirm"
            @selected="selectedVehicles"
            @exclude="excludedIds"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import appConfig from '@/app.config'
import { Helper } from '@/mixin/helper'
import McGrapqlTable from '@/components/McGrapqlTable'
import {
  CREATE_VEHICLES_2_SSGROUP,
  VEHICLE_2_SSGROUP,
  DELETE_VEHICLES_2_SSGROUP,
} from '@/services/api/maintenance/ssgroup'
import { mapGetters } from 'vuex'
import McEmptyState from '@/components/McEmptyState'
import { GET_SERVICES_2_SSGROUP } from '@/services/api/maintenance/ssgroup'
import McButtonValueHelp from '@/components/McButtonValueHelp'
import McButton from '@/components/McButton'
import { GET_VEHICLES_PAGINATED } from '@/services/api/master/fleet'
import { GET_SERVICE_SCHEDULES_BY_VEHICLE } from '@/services/api/maintenance/serviceSchedules'
import { jwtSign } from '@/helpers/jwt.js'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Servis',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: {
    McGrapqlTable,
    McEmptyState,
    McButtonValueHelp,
    McButton,
  },

  mixins: [Helper],
  apollo: {
    vehicle2Ssgroup: {
      query: VEHICLE_2_SSGROUP,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            ssgroupId: [Number(this.$route.params.ssgroupId)],
            pagination: {
              page: 1,
              show: 99999,
            },
          },
        }
      },
      result({ data, loading }) {
        if (loading) {
          return
        }

        if (data.vehicle2Ssgroup.vehicles2Ssgroup.data.length == 0) this.hasData = false
        else this.hasData = true

        if (this.isDuplicate) this.hasData = false

        this.vehiclesId = data.vehicle2Ssgroup.vehicles2Ssgroup.data.map((item) => item.id)
      },
    },
    services2Ssgroup: {
      query: GET_SERVICES_2_SSGROUP,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            ssgroupId: [Number(this.$route.params.ssgroupId)],
            type: ['DistanceAndTime', 'Hourmeter'],
            pagination: {
              page: 1,
              show: 99999,
            },
          },
        }
      },
      result({ data, loading }) {
        if (loading) {
          return
        }
        this.render = false

        const services = data.services2Ssgroup.services2Ssgroup.data
        this.servicesId = services.map((item) => item.serviceId)

        setTimeout(() => {
          this.render = true
        }, 500)
      },
    },
  },

  props: ['disabled', 'isDuplicate', 'hasTemplate'],

  data() {
    return {
      vehiclesId: [],
      refresh: false,
      filter: {},
      vehicles: [],
      hasData: false,
      servicesId: [],
      render: true,
      selectionMode: 'Selection',
      lastError: null,
    }
  },

  computed: {
    title() {
      return this.$t('maintenance.detailSchedule.title')
    },

    fields() {
      return [
        {
          key: 'licensePlate',
          label: this.$t('global.object.licensePlate'),
          sortable: true,
          isRedirectable: false,
        },
        {
          key: 'vehicleType.type',
          label: this.$t('global.field.vehicleType'),
          sortable: true,
        },
        {
          key: 'manufacturer',
          label: this.$t('setting.list.fleetSetting.fleetModel'),
          sortable: true,
        },
      ]
    },

    optionsFields() {
      return [
        {
          key: 'licensePlate',
          label: this.$t('global.object.licensePlate'),
          sortable: true,
        },
        {
          key: 'vehicleType.type',
          label: this.$t('global.field.vehicleType'),
          sortable: true,
        },
        {
          key: 'vehicleType.category',
          label: this.$t('global.object.fleetCategory'),
          sortable: true,
        },
        {
          key: 'vehicleType.model',
          label: this.$t('setting.list.fleetSetting.fleetModel'),
          sortable: true,
        },
        {
          key: 'vehicle2Vgroup',
          label: this.$t('global.object.fleetGroup'),
          sortable: true,
          formatter: (val) => {
            return val.map((item) => item.vgroup.name).join(', ')
          },
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          const res = await this.$apollo.query({
            query: VEHICLE_2_SSGROUP,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                ...filter,
                ssgroupId: [Number(this.$route.params.ssgroupId)],
              },
            },
          })

          return res.data.vehicle2Ssgroup.vehicles2Ssgroup
        },
        delete: async (id) => {
          this.lastError = null
          const res = await this.$apollo.mutate({
            mutation: DELETE_VEHICLES_2_SSGROUP,
            variables: {
              input: {
                vehicle: {
                  vehicleId: [Number(id)],
                },
                ssgroupId: [Number(this.$route.params.ssgroupId)],
              },
            },
          })

          if (!res.data.deleteVehicle2Ssgroup.isSuccessful) {
            this.lastError = {
              code: res.data.deleteVehicle2Ssgroup.errorCode,
              name: res.data.deleteVehicle2Ssgroup.errorName,
            }
          }

          return res.data.deleteVehicle2Ssgroup.isSuccessful
        },
      }
    },

    resourcefulQuery() {
      return {
        vehicles: async (opts) => {
          const filter = {
            pagination: {
              page: opts.page,
              show: opts.limit,
            },
            parentOnly: true,
            search: opts.search,
          }

          const res = await this.$apollo.query({
            query: GET_VEHICLES_PAGINATED,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                ...filter,
                excludeVehicleId: this.vehiclesId,
              },
            },
          })

          const self = this
          self.vehiclesList = res.data.vehiclesPaginated.vehiclesPaginated.data

          const result = {
            metadata: {
              total_count: res.data.vehiclesPaginated.vehiclesPaginated.pagination.total,
              page: res.data.vehiclesPaginated.vehiclesPaginated.pagination.page,
            },
            data: {
              paginated_result: res.data.vehiclesPaginated.vehiclesPaginated.data,
            },
          }

          return result
        },
      }
    },

    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      isMetrack: 'identity/isMetrack',
    }),

    illustrationPath() {
      if (this.isWhitelabel() || this.isMetrack()) {
        return require(`@/assets/images/illustration/whitelabel/no-data.svg`)
      }
      return require(`@/assets/images/illustration/saas/no-data.svg`)
    },
  },

  methods: {
    async get() {
      const res = await this.$apollo.queries.vehicle2Ssgroup.refetch({
        filter: {
          pagination: {
            page: 1,
            show: 99999,
          },
          ssgroupId: [Number(this.$route.params.ssgroupId)],
        },
      })

      this.vehiclesId = res.data.vehicle2Ssgroup.vehicles2Ssgroup.data.map((item) => item.id)
    },

    async addVehicles(value) {
      this.refresh = true
      const vehicleId = value
      const res = await this.$apollo.mutate({
        mutation: CREATE_VEHICLES_2_SSGROUP,
        variables: {
          input: {
            ssgroupId: Number(this.$route.params.ssgroupId),
            vehicle: {
              selectionMode: this.selectionMode,
              vehicleId: vehicleId,
            },
          },
        },
      })

      if (res.data.createVehicle2Ssgroup.isSuccessful) {
        this.$mcToast.success(this.$t('global.alert.text.saved'))
      }

      this.$emit('refreshData')

      this.get()
      setTimeout(() => {
        this.refresh = false
      }, 500)
    },

    customToast() {
      let errorMessage = this.$t('maintenance.alert.failedDeteleUsed')

      if (this.lastError?.code === 'E-VSG1-D1/4' && this.lastError?.name === 'ResourceBeingUsed') {
        errorMessage = this.$t('maintenance.alert.vehicleUsedInMO')
      }

      this.$mcToast.error({
        component: 'McToastDynamicBody',
        props: {
          contents: [
            {
              tag: 'h6',
              text: this.$t('maintenance.alert.deleteFailed'),
            },
            {
              tag: 'p',
              text: errorMessage,
            },
          ],
        },
      })
    },

    async selectedVehicles(value) {
      const selectedIds = value.map((item) => item)
      this.selectionMode = 'Selection'

      const { data } = await this.$apollo.query({
        client: 'clientLowPrio',
        query: GET_SERVICE_SCHEDULES_BY_VEHICLE,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            pagination: {
              show: 100,
              page: 1,
            },
            serviceId: this.servicesId,
            vehicle: {
              selectionMode: this.selectionMode,
              vehicleId: selectedIds,
            },
          },
        },
      })

      if (data.serviceSchedulesByVehicle.serviceSchedulesByVehicle.data.length) {
        const encryptedIds = await this.encryptIds(selectedIds, this.servicesId, this.selectionMode)

        this.$router.push({
          name: 'Scheduled Conflict',
          param: { ssgrooupId: this.$route.params.ssgroupId },
          query: { ids: encryptedIds },
        })
      } else {
        this.addVehicles(selectedIds)
      }
    },
    openModal() {
      this.$bvModal.show('mc-modal-confirm')
    },

    async encryptIds(vehicleId, serviceId, selectionMode) {
      const payload = { vehicleId, serviceId, selectionMode }
      const token = await jwtSign({ payload: payload })
      return token
    },
    async excludedIds(value) {
      value.map((id) => {
        this.vehiclesId.push(id)
      })

      this.selectionMode = 'Exclude'

      const { data } = await this.$apollo.query({
        client: 'clientLowPrio',
        query: GET_SERVICE_SCHEDULES_BY_VEHICLE,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            pagination: {
              show: 100,
              page: 1,
            },
            serviceId: this.servicesId,
            vehicle: {
              selectionMode: this.selectionMode,
              vehicleId: this.vehiclesId,
            },
          },
        },
      })

      if (data.serviceSchedulesByVehicle.serviceSchedulesByVehicle.data.length) {
        const encryptedIds = await this.encryptIds(
          this.vehiclesId,
          this.servicesId,
          this.selectionMode
        )

        this.$router.push({
          name: 'Scheduled Conflict',
          param: { ssgrooupId: this.$route.params.ssgroupId },
          query: { ids: encryptedIds },
        })
      } else {
        this.addVehicles(value)
      }
    },
  },
}
</script>
